<script setup>
import { computed } from 'vue';
import { trans } from '@tools/translation';

const props = defineProps({
  offer: {
    type: Object,
    required: true,
  },
});

const show = computed(() => props.offer.is_offmarket);
</script>

<template>
  <span v-if="show" class="hit-label hit-label--proposal_offmarket">
    {{ trans('offer_card.labels.proposal_offmarket') }}
  </span>
</template>
